<template>
  <div class="uploader-container">
    <van-uploader :fileList="fileList" accept="image/png, image/jpg, image/jpeg" v-if="captureMode == 'environment'"
      multiple :max-count="5" :max-size="20 * 1024 * 1024" :before-read="handleBeforeRead" :after-read="handleAfterRead"
      @oversize="handleOversize" @delete="handleDelete" ref="uploaderRef">
      <div class="van-uploader__upload">
        <van-icon name="plus" />
      </div>
    </van-uploader>

    <van-uploader :fileList="fileList" accept="image/png, image/jpg, image/jpeg" v-if="captureMode == 'camera'"
      :capture="captureMode" multiple :max-count="5" :max-size="20 * 1024 * 1024" :before-read="handleBeforeRead"
      :after-read="handleAfterRead" @oversize="handleOversize" @delete="handleDelete">
      <div class="van-uploader__upload">
        <van-icon name="photograph" />
      </div>
    </van-uploader>

    <div class="upload-options">
      <van-button type="primary" size="small" @click="setCaptureMode('camera')"
        :class="{ active: captureMode === 'camera' }">
        拍照
      </van-button>
      <van-button type="primary" size="small" @click="setCaptureMode('environment')"
        :class="{ active: captureMode === 'environment' }">
        相册
      </van-button>
    </div>
  </div>

</template>

<script>
import { upload } from '@/api/common';
export default {
  name: 'UploadImage',
  data() {
    return {
      fileList: [],
      captureMode: "environment"
    }
  },
  watch: {
    fileList: {
      handler(newVal) {
        const url = newVal.map(item => item.url).join();
        this.$emit('uploadImage', url);
      },
      deep: true
    }
  },
  methods: {
    setCaptureMode(mode) {
      this.captureMode = mode
      // 当模式为environment时，自动唤起上传器
      if (mode === 'environment') {
        // 通过ref调用组件方法
        this.$refs.uploaderRef && this.$refs.uploaderRef.chooseFile()
      }
    },
    handleDelete(file) {
      // 删除文件
      this.fileList = this.fileList.filter(item => item.filename !== file.filename);
    },
    /**
     * 	文件读取前的回调函数，返回false可终止文件读取
     */
    handleBeforeRead(file) {
      const imgType = ['image/jpeg', 'image/png', 'image/jpg'];
      if (Array.isArray(file)) {
        file.forEach(item => {
          if (imgType.indexOf(item.type) === -1) {
            this.$toast('请上传图片');
            return false;
          }
        })
      } else if (imgType.indexOf(file.type) === -1) {
        this.$toast('请上传图片');
        return false;
      }
      return true;
    },
    /**
     * 文件读取完成后的回调函数
     */
    handleAfterRead(file) {
      if (Array.isArray(file)) { // 多图片上传
        const promiseList = file.map(item => this.uploadImage(item.file));
        Promise.all(promiseList)
          .then((res) => {
            this.fileList = res.map(item => item[0]);
          })
          .catch((err) => {
            this.$toast(err.message ? err.message : '上传失败');
            console.log(err);
          });
      } else {
        this.uploadImage(file.file).then((res) => {
          this.fileList.push(res[0]);
        })
          .catch((err) => {
            this.$toast(err.message ? err.message : '上传失败');
            console.log(err);
          })
      }
    },
    /**
     * 上传图片
     */
    uploadImage(file) {
      return new Promise((resolve, reject) => {
        const formFileData = new FormData();
        formFileData.append('file', file);
        upload(formFileData).then(res => {
          if (res.errcode === 0) {
            // 上传成功
            resolve(res.data);
          } else {
            reject(res);
          }
        })
      });
    },
    handleOversize() {
      this.$toast('文件大小不能超过2M');
    }
  }
}
</script>

<style lang="less" scoped>
.uploader-container {
  padding: 20px;
}

.upload-options {
  margin: 20px 0;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.active {
  background-color: #1989fa;
  border-color: #1989fa;
}

.preview {
  margin-top: 20px;
  text-align: center;
}

.preview img {
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>